import React from "react";
import { ShieldCheck, TrendingUp, AlertCircle } from "lucide-react";

/**
 * TrustScoreBadge — circular badge showing 0-100 score with band-based colour.
 *
 * 0-39   red    (Low trust)
 * 40-69  amber  (Building trust)
 * 70-89  green  (Trusted)
 * 90-100 gold   (Top seller)
 *
 * Props:
 *   score: 0-100
 *   size: "sm" | "md" | "lg"
 *   lang: "ar" | "en"
 *   showLabel: boolean
 */
export default function TrustScoreBadge({ score = 0, size = "sm", lang = "ar", showLabel = true }) {
  const v = Math.max(0, Math.min(100, Number(score) || 0));
  let color, bg, border, label;
  if (v >= 90) { color = "#8a6f2e"; bg = "rgba(201,165,92,0.15)"; border = "rgba(201,165,92,0.50)"; label = lang === "ar" ? "بائع مميّز" : "Top seller"; }
  else if (v >= 70) { color = "#0a4f3a"; bg = "rgba(10,79,58,0.10)"; border = "rgba(10,79,58,0.35)"; label = lang === "ar" ? "موثوق" : "Trusted"; }
  else if (v >= 40) { color = "#8a6f2e"; bg = "#fef9ed"; border = "rgba(201,165,92,0.30)"; label = lang === "ar" ? "بناء ثقة" : "Building"; }
  else { color = "#b91c1c"; bg = "rgba(220,38,38,0.08)"; border = "rgba(220,38,38,0.30)"; label = lang === "ar" ? "ثقة منخفضة" : "Low trust"; }

  const sizes = {
    sm: { box: "px-2 py-0.5 text-[10px]", num: "text-[11px]" },
    md: { box: "px-2.5 py-1 text-xs", num: "text-sm" },
    lg: { box: "px-3.5 py-1.5 text-sm", num: "text-base" },
  }[size] || { box: "px-2 py-0.5 text-[10px]", num: "text-[11px]" };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold border ${sizes.box}`}
      style={{ backgroundColor: bg, color: color, borderColor: border }}
      data-testid="trust-badge"
      title={lang === "ar" ? `نقاط الثقة: ${v}/100` : `Trust score: ${v}/100`}
    >
      {v >= 70 ? <ShieldCheck className="w-3 h-3" /> : v >= 40 ? <TrendingUp className="w-3 h-3" /> : <AlertCircle className="w-3 h-3" />}
      <span className={`font-bold ${sizes.num}`}>{v}</span>
      {showLabel && <span>· {label}</span>}
    </span>
  );
}
